import { combineReducers } from "@reduxjs/toolkit";

import { default as cart } from "./cart";
import { default as order } from "./order";
import { default as rfq } from "./rfq";
import { default as rfqList } from "./rfq/rfq-list/reducer";

export default combineReducers({ cart, order, rfq, rfqList });

export type { IShoppingReducerState } from "./types";
